// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__32U-V","overflowing":"ReadFullNote_overflowing__3UMS6"};